var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 612 612",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M153,114.75h1.592c15.845,0,28.688-12.842,28.688-28.688V76.5V28.688C183.28,12.842,170.437,0,154.592,0H153 c-15.845,0-28.688,12.842-28.688,28.688V76.5v9.562C124.312,101.908,137.155,114.75,153,114.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.438,114.75h1.592c15.846,0,28.688-12.842,28.688-28.688V76.5V28.688C479.717,12.842,466.875,0,451.029,0h-1.592 c-15.845,0-28.688,12.842-28.688,28.688V76.5v9.562C420.75,101.908,433.593,114.75,449.438,114.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.5,76.5h-27.096v9.562c0,31.638-25.737,57.375-57.375,57.375h-1.592c-31.638,0-57.375-25.737-57.375-57.375V76.5 H211.967v9.562c0,31.638-25.738,57.375-57.375,57.375H153c-31.638,0-57.375-25.737-57.375-57.375V76.5H76.5 C34.253,76.5,0,110.753,0,153v382.5C0,577.747,34.253,612,76.5,612h459c42.247,0,76.5-34.253,76.5-76.5V153 C612,110.753,577.747,76.5,535.5,76.5z M573.75,535.5c0,21.104-17.146,38.25-38.25,38.25h-459c-21.085,0-38.25-17.146-38.25-38.25 v-306h535.5V535.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 325.125,
    r: 47.019
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 325.125,
    r: 47.019
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459,
    cy: 325.125,
    r: 47.019
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 478.125,
    r: 47.019
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306,
    cy: 478.125,
    r: 47.019
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459,
    cy: 478.125,
    r: 47.019
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.6da1c78f19cb3e3ada10d69287dfa010.svg";
export { ForwardRef as ReactComponent };